// extracted by mini-css-extract-plugin
export default {"quote-detail":"QuoteDetail_quote-detail__e8fI5"};